import { put } from 'helpers/api';
import { showSnackbar } from 'components/ui/snackbar/helper';
import { buildCustomStage } from 'bundles/apex/pipeline/settings/stages/helpers';
import { requestErrors } from 'helpers/api_errors';

export const UPDATE_STAGES = 'UPDATE_STAGES';
export function updateStages(stages) {
  return {
    type: UPDATE_STAGES,
    stages,
  };
}

export const UPDATE_BROKER_GROSS = 'UPDATE_BROKER_GROSS';
export function updateBrokerGross(brokerGross) {
  return {
    type: UPDATE_BROKER_GROSS,
    brokerGross,
  };
}

export const UPDATE_COLUMNS = 'UPDATE_COLUMNS';
export function updateColumns(columns) {
  return {
    type: 'UPDATE_COLUMNS',
    columns,
  };
}

export const SET_SELECTED_STAGE = 'SELECTED_STAGE';
export function setSelectedStage(stage) {
  return {
    type: SET_SELECTED_STAGE,
    stage,
  };
}

export const SET_SAVING = 'SET_SAVING';
export function setSaving(saving) {
  return {
    type: SET_SAVING,
    saving,
  };
}

export const SET_ERRORS = 'SET_ERRORS';
export function setErrors(errors) {
  return {
    type: SET_ERRORS,
    errors,
  };
}

export function updateSelectedStage(stage) {
  return async (dispatch) => {
    dispatch(setErrors(null));
    dispatch(setSelectedStage(stage));
  };
}

export function saveChanges(stage) {
  return async (dispatch, getState) => {
    dispatch(setSaving(true));
    const { stages, path } = getState();
    const customStages = {};
    const updatedStages = { ...stages, [stage.key]: stage };

    for (const key in updatedStages) {
      const customStage = buildCustomStage(updatedStages[key]);
      if (customStage) {
        customStages[key] = { ...customStage };
      }
    }

    if (stage.backfillCheck) {
      customStages.backfillStage = stage.key;
    }

    try {
      const res = await put(path, customStages);
      dispatch(updateStages(res.stages));
      dispatch(setErrors(null));
      dispatch(setSelectedStage(null));
      if (res.notification?.length > 0) showSnackbar({ text: res.notification, variant: 'success' });
    } catch (e) {
      dispatch(setErrors(requestErrors(e, 'An error occurred while saving changes.')));
    }

    dispatch(setSaving(false));
  };
}
